import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const useIndustryApprovalStatus = (profileExists) => {
  const [isIndustryApproved, setIsIndustryApproved] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!profileExists) return; 

    const fetchApprovalStatus = async () => {
      try {
        const res = await fetch(`${BASE_URL}/marketplace/industry/approval_status`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        const data = await res.json();
        // console.log("The document status is:",data)
        if (data?.approval_status === false) {
          navigate("/marketplace/industry/status");
          setIsIndustryApproved(false)
        }
        else{
           setIsIndustryApproved(true)
        }
      } catch (err) {
        console.error(err);
        navigate("/marketplace/industry"); // redirect on error
      }
    };

    fetchApprovalStatus();
  }, [navigate, profileExists]);

  return isIndustryApproved ;
};

export default useIndustryApprovalStatus;
